// extracted by mini-css-extract-plugin
export default {"sectionContainer":"nivelacijaKvota_sectionContainer__G+fMt","button":"nivelacijaKvota_button__dE3ar"};